import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import SafeHTML from "./SafeHTML";
import ImageBlock from "./ImageBlock";
import ButtonLink from "./ButtonLink";
import style from '../../scss/components/EmbeddedCTA';
export default class EmbeddedCTA extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string,
        icon: CustomPropTypes.Image,
        link: CustomPropTypes.Link,
    };
    render() {
        return (
            <section className="cta-section">
                <div className="container">
                    <div className="cta-card">
                        <ImageBlock image={this.props.icon} addWrapper={false} />
                        <h3>{this.props.title}</h3>
                        <p><SafeHTML>{this.props.description}</SafeHTML></p>
                        <ButtonLink icon="icon icon-direction-right" className="btn btn-link cta-btn" {...this.props.link} />
                    </div>
                </div>
            </section>
        );
    }
}
